import { Tab } from '@headlessui/react'
import React, { Fragment } from 'react'
import styles from './styles.module.scss'
import SoapTemplates from './childs/soapTemplates/SoapTemplates'
import PrescriptionTemplates from './childs/prescriptionTemplates/PrescriptionTemplates'
import MedicationsTemplates from './childs/medicationsTemplates/MedicationsTemplates'
import withAdmin from '../../hoc/withAdmin'
import LabTemplates from './childs/labImagingTemplates/LabTemplates'
import ImageTemplates from './childs/ImagingTemplates/ImageTemplates'

const Templates = () => (
  <div className={styles.root}>
    <span className={styles.titleh1}>Existing templates</span>
    <hr />
    <Tab.Group>
      <Tab.List className={styles.templatesRow}>
        {/* <Tab as={Fragment}>
          {({ selected }) => (
            <button
              className={selected ? styles.selected : styles.button}
              type="button"
            >
              SOAP Templates
            </button>
          )}
        </Tab> */}
        <Tab as={Fragment}>
          {({ selected }) => (
            <button
              className={selected ? styles.selected : styles.button}
              type="button"
            >
              Prescription Templates
            </button>
          )}
        </Tab>
        <Tab as={Fragment}>
          {({ selected }) => (
            <button
              className={selected ? styles.selected : styles.button}
              type="button"
            >
              Medications Templates
            </button>
          )}
        </Tab>
        <Tab as={Fragment}>
          {({ selected }) => (
            <button
              className={selected ? styles.selected : styles.button}
              type="button"
            >
              Lab Templates
            </button>
          )}
        </Tab>
        <Tab as={Fragment}>
          {({ selected }) => (
            <button
              className={selected ? styles.selected : styles.button}
              type="button"
            >
              Imaging Templates
            </button>
          )}
        </Tab>
      </Tab.List>
      <Tab.Panels>
        {/* <Tab.Panel>
          <SoapTemplates />
        </Tab.Panel> */}
        <Tab.Panel>
          <PrescriptionTemplates />
        </Tab.Panel>
        <Tab.Panel>
          <MedicationsTemplates />
        </Tab.Panel>
        <Tab.Panel>
          <LabTemplates />
        </Tab.Panel>
        <Tab.Panel>
          <ImageTemplates />
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  </div>
)

export default withAdmin(Templates)
